import { useState, useEffect } from 'react'
import { Typography } from 'antd'
import { CookieManager } from '../../utils/cookies'
import { Link } from 'react-router-dom'

const { Text } = Typography

const MinimalCookieConsent = () => {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    // Check if user has already given consent
    const consent = CookieManager.getConsent()
    if (!consent && CookieManager.isEnabled()) {
      setVisible(true)
    }
  }, [])

  const handleAccept = () => {
    // Save consent for admin functionality cookies only
    CookieManager.saveConsent(false, true) // No analytics, only functional
    setVisible(false)
  }

  const handleDismiss = () => {
    // Dismiss without accepting (session only)
    setVisible(false)
  }

  if (!visible) return null

  return (
    <div 
      className="fixed z-[9999] w-full flex justify-center animate-slideUp"
      style={{ 
        bottom: '24px',
        left: 0,
        right: 0,
      }}
    >
      <div 
        className="mx-4 flex items-center gap-6 px-6 py-4 rounded-full shadow-lg"
        style={{
          backgroundColor: '#374151',
          maxWidth: '600px',
          width: 'auto',
        }}
      >
        <Text className="text-sm" style={{ color: '#ffffff' }}>
          We use cookies for secure admin access.{' '}
          <Link 
            to="/cookies" 
            className="inline-flex items-center gap-1 hover:opacity-80 transition-opacity"
            style={{ color: '#60a5fa', textDecoration: 'none' }}
          >
            Details
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M7 17L17 7M17 7H7M17 7V17" />
            </svg>
          </Link>
        </Text>
        
        <div className="flex items-center gap-2">
          <button
            onClick={handleDismiss}
            className="px-4 py-1.5 text-sm font-medium rounded-full transition-all hover:bg-gray-800"
            style={{ 
              color: '#9ca3af',
              backgroundColor: 'transparent',
            }}
          >
            Dismiss
          </button>
          <button
            onClick={handleAccept}
            className="px-4 py-1.5 text-sm font-medium rounded-full transition-all hover:opacity-90"
            style={{ 
              color: '#1a1a1a',
              backgroundColor: '#ffffff',
            }}
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  )
}

export default MinimalCookieConsent